import { Language } from 'apollo/generated/types';

const isApiLanguage = (value: string): value is Language =>
  (Object.values(Language) as string[]).includes(value);

const getApiLanguage = (language: string): Language =>
  isApiLanguage(language) ? language : Language.Es;

export default getApiLanguage;
